import { TickLabelProps } from '@visx/axis';
import { NumberValue } from 'd3-scale';

export const tickLabelProps: TickLabelProps<NumberValue> = {
  fill: '#AEAEB2',
  fontSize: 12,
};
